// /frontend/components/fca/FCATable.jsx
import React from 'react';
import { SHADOWS } from '../../theme/tokens';
import {
  Table, TableHead, TableBody, TableRow, TableCell,
} from '@mui/material';
import TableViewport from '../common/TableViewport';
import { formatInt, formatMoney, formatNumber, formatPercent } from '../../utils/format';

const eur = (n) => formatMoney(n);

// Columns hidden on mobile (xs): keep SKU, Units, Revenue, COGS, Total Cost, Margin, Margin%
const HIDE = { display: { xs: 'none', sm: 'table-cell' } };

export default function FCATable({ rows = [] }) {
  return (
    <TableViewport sx={{ WebkitOverflowScrolling: 'touch' }}>
      <Table
        size="small"
        sx={{
          borderCollapse: 'separate',
          borderSpacing: 0,
          '& thead th': {
            bgcolor: (theme) => theme.palette.grey[100],
            borderBottom: '1px solid',
            borderColor: 'divider',
            whiteSpace: 'nowrap',
            lineHeight: 1.4,
            fontSize: 12,
          },
          '& .MuiTableCell-root': {
            py: 1,
            px: 1.5,
            borderBottom: '1px solid',
            borderColor: 'divider',
          },
          // Sticky first column (SKU)
          '& thead th:first-of-type, & tbody td:first-of-type': {
            position: 'sticky',
            left: 0,
            zIndex: 2,
            bgcolor: 'background.paper',
            boxShadow: SHADOWS.stickyColumn,
          },
          '& thead th:first-of-type': {
            zIndex: 3,
            bgcolor: (theme) => theme.palette.grey[100],
          },
        }}
      >
        <TableHead>
          <TableRow>
            <TableCell>SKU</TableCell>
            <TableCell align="right">Units</TableCell>
            <TableCell align="right">Revenue</TableCell>
            <TableCell align="right">COGS</TableCell>
            <TableCell align="right" sx={HIDE}>Fulfill</TableCell>
            <TableCell align="right" sx={HIDE}>Transport</TableCell>
            <TableCell align="right" sx={HIDE}>Storage</TableCell>
            <TableCell align="right" sx={HIDE}>Overhead</TableCell>
            <TableCell align="right">Total Cost</TableCell>
            <TableCell align="right">Margin</TableCell>
            <TableCell align="right">Margin %</TableCell>
            <TableCell align="right" sx={HIDE}>Cost/Unit</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.map((r) => (
            <TableRow key={r.sku} hover>
              <TableCell>{r.sku}</TableCell>
              <TableCell align="right">{formatInt(r.units_sold)}</TableCell>
              <TableCell align="right">{eur(r.revenue_net)}</TableCell>
              <TableCell align="right">{eur(r.cogs_net)}</TableCell>
              <TableCell align="right" sx={HIDE}>{eur(r.alloc_fulfill_net)}</TableCell>
              <TableCell align="right" sx={HIDE}>{eur(r.alloc_transport_net)}</TableCell>
              <TableCell align="right" sx={HIDE}>{eur(r.alloc_storage_net)}</TableCell>
              <TableCell align="right" sx={HIDE}>{eur(r.overhead_net)}</TableCell>
              <TableCell align="right">{eur(r.total_cost_net)}</TableCell>
              <TableCell align="right">{eur(r.margin_abs)}</TableCell>
              <TableCell align="right">{formatPercent(Number(r.margin_pct), { digits: 1 })}</TableCell>
              <TableCell align="right" sx={HIDE}>{formatNumber(r.cost_per_unit, { digits: 4 })}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableViewport>
  );
}
